"use client";

import { useEffect } from "react";

import { getCookie, setCookie } from "cookies-next";

import {
  ATTR_REFERRER_COOKIE,
  ATTR_URL_COOKIE,
  PS_STATE_COOKIE,
} from "~/utils/constants";
import { createCookieOptions } from "~/utils/cookie-utils";

export const trackReferrer = () => {
  const attrUrl = getCookie(ATTR_URL_COOKIE) ?? "";
  const attrReferrer = getCookie(ATTR_REFERRER_COOKIE) ?? "";
  let link = location.href;
  let ref = document.referrer;
  let setCookies = false;

  if (!attrUrl && !attrReferrer) {
    setCookies = true;
    // if they have already been a PS visitor, tag as unknown
    // since we haven't tracked their initial referrer
    if (getCookie(PS_STATE_COOKIE)) {
      link = "unknown";
      ref = "unknown";
    }
  } else {
    const oldCampaign =
      (attrUrl as string).indexOf("utm_") === -1 ? false : true;
    const newCampaign = link.indexOf("utm_") === -1 ? false : true;
    const peerspaceReferrer = ref.indexOf("peerspace.com") !== -1;
    // considered a PS overwrite if there is an existing referrer
    // already set when a peerspace.com referrer is detected
    const peerspaceOverwrite = attrReferrer && peerspaceReferrer;
    // we are only counting a new referrer url - like organic search from google
    // if there isn't already campaign info. we don't want to wipe that out
    // also, don't count self referrals from the blog / boards / tastemakers /
    // support unless it's the first referral (2/28 update)
    const newReferrer = ref && !peerspaceOverwrite && !oldCampaign;
    setCookies = !!(newCampaign || newReferrer);
  }

  if (setCookies) {
    const twoWeeksInMilliseconds = new Date(
      Date.now() + 14 * 24 * 60 * 60 * 1000,
    );
    const cookieOptions = createCookieOptions({
      expires: twoWeeksInMilliseconds,
    });

    setCookie(ATTR_URL_COOKIE, link, cookieOptions);
    setCookie(ATTR_REFERRER_COOKIE, ref, cookieOptions);
  }
};

export const TrackReferrer = () => {
  useEffect(() => {
    trackReferrer();
  }, []);

  return null;
};
